<template>
  <!-- {{ Bind v-if to the isLoading state from the UI store }} -->
  <div class="loader-wrapper" v-if="uiStore.isLoading || !showContent">
    <div class="loader"><span></span><span></span><span></span><span></span><span></span></div>
  </div>
  <router-view v-if="showContent" />
</template>
<script lang="ts" setup>
import { onMounted, watch, onUnmounted, ref } from "vue" // Removed ref
import { useRouter } from 'vue-router'
import { useUiStore } from "@/store/ui" // {{ Import the UI store }}
import * as auth from "@/api/services/AuthRequest"
import * as setting from "@/api/services/SettingRequest"
import * as master from "@/api/services/MasterRequest"
import { useSessionStore } from '@/store/session';
const session = useSessionStore()

const showContent = ref<boolean>(false)
const checkValidation = async () => {
  const token = await localStorage.getItem('token')
  if (token) {
    await auth.checkRequest().then((res: any) => {
      if (res.status != 200) {
        router.push('/auth/login')
      } else {
        if (session.schema_app == 'CLINIC') {
          fetchClinic();
        } else {
          fetchDivision();
        }
      }
    }).catch((err: any) => {
      router.push('/auth/login')
    })
  } else {
    router.push('/auth/login')
  }
  showContent.value = true;
}
checkValidation()
async function fetchClinic() {
  await setting
    .postRequest("/clinic/list", { page: 1, size: 10000, search: "" })
    .then((resp: any) => {
      if (resp.status === 200) {
        localStorage.setItem('clinic', JSON.stringify(resp.data)) // {{ Use localStorage directly }}
      }
    })
}
async function fetchDivision() {
  await master
    .postRequest("/divisi/list", { page: 1, size: 10000, search: "" })
    .then((resp: any) => {
      if (resp.status === 200) {
        localStorage.setItem('division', JSON.stringify(resp.data)) // {{ Use localStorage directly }}
      }
    })
}
const router = useRouter() // {{ Use const for router }}
const uiStore = useUiStore() // {{ Get the UI store instance }}

watch(
  () => router.currentRoute.value, // Watch the current route object for changes
  () => {
    // {{ Call the action from the UI store }}
    uiStore.showLoaderForDuration(300);
  },
  { deep: true, immediate: false }, // immediate: false might be better to avoid initial trigger if not needed
);

function add() {
  // {{ Use the store instance directly }}
}

onMounted(() => {
  let allBgImageCover = document.getElementsByClassName('bg-img-cover');
  window.addEventListener('beforeunload', add)
  const cartData = localStorage.getItem('cart')
  // {{ Use the store instance directly }}
  setTimeout(() => {
    for (let i = 0; i < allBgImageCover.length; i++) {
      var image = allBgImageCover[i] as HTMLElement // Type assertion
      var parentEl = image.parentElement // parentElement is already HTMLElement | null
      var src = image.getAttribute('src')
      if (parentEl && src) { // Check if parentEl and src exist
        parentEl.style.backgroundImage = "url(" + src + ")"
        parentEl.style.backgroundSize = "cover"
        parentEl.style.backgroundPosition = "center"
        parentEl.classList.add('bg-size')
        image.classList.add('d-none')
      }
    }
  }, 0);
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', add)
})
</script>
